import type { FC } from 'react';
import { useContext } from 'react';
import { __RouterContext } from 'react-router';
import { Redirect, withRouter } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router';
import type { RedirectProps } from 'react-router-dom';

// TODO: After @salesforce/pwa-kit-react-sdk@3.9.0, we can use the RedirectWithStatus component from the @salesforce/pwa-kit-react-sdk package

type RedirectWithStatusProps = RedirectProps & { status?: number } & RouteComponentProps;
const RedirectWithStatusImpl: FC<RedirectWithStatusProps> = ({ status, ...props }) => {
    // Handle server-side rendering
    const { staticContext } = useContext(__RouterContext);
    if (staticContext) {
        staticContext.statusCode = status ?? 302;
    }

    return <Redirect {...props} />;
};

RedirectWithStatusImpl.displayName = 'RedirectWithStatusImpl';
RedirectWithStatusImpl.defaultProps = { status: 302 };

const RedirectWithStatus = withRouter(RedirectWithStatusImpl);

RedirectWithStatus.displayName = 'RedirectWithStatus';
RedirectWithStatus.defaultProps = { status: 302 };

export { RedirectWithStatus };
